export const checksums = {
  "articles": "v3.5.0--RrbnZNc9v2x1Wz9Lcg3-BaZVHC1W1N2h8dHR6jYfWBE"
}
export const checksumsStructure = {
  "articles": "bQyqrqG_jk9yhVhrJBMvqGMcrFaKjtSGf8sOyEkvB_M"
}

export const tables = {
  "articles": "_content_articles",
  "info": "_content_info"
}

export default {
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "aiGenerated": "boolean",
      "body": "json",
      "cover": "string",
      "date": "string",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}